/* Albindress — drop.js
   Conto alla rovescia del drop settimanale (fuso Europe/Rome, ora legale inclusa),
   stato «drop online», banda di testo scorrevole con pausa. */
(function () {
  'use strict';

  const A = (window.Albin = window.Albin || {});
  const cfg = Object.assign({ weekday: 3, hour: 18, liveHours: 24, timeZone: 'Europe/Rome' }, A.drop || {});
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- Calcolo date nel fuso del negozio ---------- */
  let formatter;
  try {
    formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: cfg.timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      weekday: 'short',
    });
  } catch (e) {
    formatter = null;
  }
  const WEEKDAYS = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

  function zoned(date) {
    if (!formatter) {
      return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate(), h: date.getHours(), mi: date.getMinutes(), s: date.getSeconds(), wd: date.getDay() };
    }
    const parts = {};
    formatter.formatToParts(date).forEach(function (p) {
      parts[p.type] = p.value;
    });
    return { y: +parts.year, m: +parts.month, d: +parts.day, h: +parts.hour % 24, mi: +parts.minute, s: +parts.second, wd: WEEKDAYS[parts.weekday] };
  }

  /* Differenza in minuti tra l'ora del fuso e UTC in un dato istante */
  function offsetAt(date) {
    const z = zoned(date);
    return (Date.UTC(z.y, z.m - 1, z.d, z.h, z.mi, z.s) - Math.floor(date.getTime() / 1000) * 1000) / 60000;
  }

  /* Istante UTC corrispondente a una data/ora "da muro" nel fuso del negozio */
  function fromZoned(y, m, d, h) {
    const guess = Date.UTC(y, m - 1, d, h, 0, 0);
    let ts = guess - offsetAt(new Date(guess)) * 60000;
    ts = guess - offsetAt(new Date(ts)) * 60000;
    return ts;
  }

  /* Ultimo e prossimo drop rispetto a "adesso" */
  function dropWindow(now) {
    const z = zoned(now);
    let delta = (cfg.weekday - z.wd + 7) % 7;
    let next = fromZoned(z.y, z.m, z.d + delta, cfg.hour);
    if (next <= now.getTime()) next = fromZoned(z.y, z.m, z.d + delta + 7, cfg.hour);
    // L'ultimo drop è quello della settimana precedente al prossimo, ricalcolato sul fuso (ora legale)
    const nz = zoned(new Date(next));
    const lastDrop = fromZoned(nz.y, nz.m, nz.d - 7, cfg.hour);
    const liveUntil = lastDrop + cfg.liveHours * 36e5;
    return { next: next, last: lastDrop, live: now.getTime() >= lastDrop && now.getTime() < liveUntil };
  }

  A.dropWindow = dropWindow;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  /* ---------- <drop-countdown> ---------- */
  class DropCountdown extends HTMLElement {
    connectedCallback() {
      this.units = {
        days: this.querySelector('[data-cd="days"]'),
        hours: this.querySelector('[data-cd="hours"]'),
        minutes: this.querySelector('[data-cd="minutes"]'),
        seconds: this.querySelector('[data-cd="seconds"]'),
      };
      this.status = this.querySelector('[data-cd-status]');
      this.scope = this.closest('[data-drop-scope]') || this;
      this.lastAnnounced = '';
      this.tick = this.tick.bind(this);
      this.onVisibility = () => {
        if (document.visibilityState === 'visible') this.tick();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.classList.add('is-ready');
      this.tick();
      this.timer = window.setInterval(this.tick, 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    tick() {
      const now = new Date();
      const win = dropWindow(now);
      this.scope.toggleAttribute('data-drop-live', win.live);
      this.scope.querySelectorAll('[data-drop-show="live"]').forEach((el) => (el.hidden = !win.live));
      this.scope.querySelectorAll('[data-drop-show="upcoming"]').forEach((el) => (el.hidden = win.live));

      let diff = Math.max(0, Math.floor((win.next - now.getTime()) / 1000));
      const days = Math.floor(diff / 86400);
      diff -= days * 86400;
      const hours = Math.floor(diff / 3600);
      diff -= hours * 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff - minutes * 60;
      if (this.units.days) this.units.days.textContent = pad(days);
      if (this.units.hours) this.units.hours.textContent = pad(hours);
      if (this.units.minutes) this.units.minutes.textContent = pad(minutes);
      if (this.units.seconds) this.units.seconds.textContent = pad(seconds);

      // Testo per lettori di schermo aggiornato al minuto, non ogni secondo
      if (this.status) {
        const s = A.strings || {};
        const text = win.live
          ? s.dropLive || ''
          : (s.dropNextLabel || '') + ' ' + days + ' ' + (s.dropDays || '') + ', ' + hours + ' ' + (s.dropHours || '') + ', ' + minutes + ' ' + (s.dropMinutes || '');
        if (text !== this.lastAnnounced) {
          this.status.textContent = text;
          this.lastAnnounced = text;
        }
      }
    }
  }
  if (!customElements.get('drop-countdown')) customElements.define('drop-countdown', DropCountdown);

  /* ---------- <marquee-band>: scorre solo se il movimento è consentito, con pausa ---------- */
  class MarqueeBand extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-marquee-toggle]');
      this.track = this.querySelector('[data-marquee-track]');
      if (!this.track) return;
      const update = () => this.classList.toggle('is-static', reduceMotion.matches);
      update();
      if (reduceMotion.addEventListener) reduceMotion.addEventListener('change', update);
      if (this.button) {
        this.button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        });
      }
    }
  }
  if (!customElements.get('marquee-band')) customElements.define('marquee-band', MarqueeBand);

  /* ---------- Video della hero: pausa manuale e rispetto di «riduci movimento» ---------- */
  document.querySelectorAll('[data-video-toggle]').forEach(function (button) {
    const video = button.closest('.drop-hero') && button.closest('.drop-hero').querySelector('video');
    if (!video) return;
    const s = A.strings || {};
    const sync = function () {
      const paused = video.paused;
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? s.videoPlay || 'Play' : s.videoPause || 'Pause');
    };
    if (reduceMotion.matches) {
      video.removeAttribute('autoplay');
      video.pause();
    }
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    button.addEventListener('click', function () {
      if (video.paused) video.play();
      else video.pause();
    });
    sync();
  });

  /* ---------- Lookbook: evidenzia il prodotto collegato al punto toccato ---------- */
  document.addEventListener('click', function (event) {
    const dot = event.target.closest('[data-look-dot]');
    if (!dot) return;
    const root = dot.closest('[data-look]');
    const target = root && root.querySelector('#' + CSS.escape(dot.getAttribute('aria-controls')));
    if (!target) return;
    event.preventDefault();
    root.querySelectorAll('[data-look-dot]').forEach((d) => d.setAttribute('aria-expanded', String(d === dot)));
    root.querySelectorAll('[data-look-item]').forEach((i) => i.classList.toggle('is-active', i === target));
    target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    const link = target.querySelector('a:not([aria-hidden="true"])');
    if (link) link.focus({ preventScroll: true });
  });
})();
